// Generated from the shared app source. Do not edit.
/* eslint-disable no-whitespace-before-property */
export const METHODOLOGY_VERSION = '1.0.0-rc.2'         ;
export const KARMIC_DEBT_NUMBERS = [13, 14, 16, 19]         ;



export function asKarmicDebt(value        )                          {
  return KARMIC_DEBT_NUMBERS.includes(value                    )
    ? (value                    )
    : null;
}
